

























import { defineComponent } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import useUrlFormatter from '~/hooks/useUrlFormatter';
/* @ts-ignore */
import careplanExpertImage from '@/assets/images/plp-careplan-image-banner-expert.webp';

export default defineComponent({
  setup() {
    const { translate } = useTranslations();
    const formatUrl = useUrlFormatter();

    return {
      careplanExpertImage,
      formatUrl,
      translate
    };
  }
});
